import config from "@/config";
import { UserScope, type LogtoConfig } from "@logto/react";

export const authConfig: LogtoConfig = {
  endpoint: config.LOGTO_ENDPOINT,
  appId: config.LOGTO_APP_ID,
  resources: [config.LOGTO_RESOURCE],
  scopes: [UserScope.Email, UserScope.CustomData, UserScope.Organizations, UserScope.Roles],
};
